/* globals angular */
( function () {
	'use strict';

	function reportGraph () {
		return {
			'templateUrl' : '/templates/report/report-components/report-graph/report-graph.html',
			'replace'     : true,
			'scope'       : {
				'graphData'    : '=',
				'graphOptions' : '=',
				'graphId'      : '@'
			}
		};
	}

	angular
		.module( 'app.report' )
		.directive( 'reportGraph', reportGraph );
} )();
